import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    standalone: true,
    name: 'spiritTranslation'
})
export class SpiritTranslationPipe implements PipeTransform {

    private translateService = inject(TranslateService)

    transform(spirit: any | undefined, variable: string): string {
        if (!spirit)
            return '';

        let spiritTranslation = spirit.translations?.find((x: any) => x.locale.code == (this.translateService.currentLang ?? 'es'));
        if (spiritTranslation && spiritTranslation[variable])
            return spiritTranslation[variable];

        let catalogTranslation = spirit.catalogSpirit?.translations?.find((x: any) => x.locale.code == (this.translateService.currentLang ?? 'es'));
        if (catalogTranslation && catalogTranslation[variable])
            return catalogTranslation[variable];

        if (spirit[variable] && spirit[variable] != '')
            return spirit[variable];

        if (spirit.catalogSpirit[variable] && spirit.catalogSpirit[variable] != '')
            return spirit.catalogSpirit[variable];

        spiritTranslation = spirit.translations[0] ?? null;
        if (spiritTranslation && spiritTranslation[variable] && spiritTranslation[variable] != '')
            return spiritTranslation[variable];

        catalogTranslation = spirit.catalogSpirit?.translations[0] ?? null;
        if (catalogTranslation && catalogTranslation[variable] && catalogTranslation[variable] != '')
            return catalogTranslation[variable];

        return '';
    }
}